import { type EditConfigUI, TemplateId } from '@types';

export const TEMPLATE_DEFAULT = '_DEFAULT_';

export type TemplateConfigId = TemplateId | typeof TEMPLATE_DEFAULT;

type TRecord<T> = Partial<Record<TemplateId, T>> & { [TEMPLATE_DEFAULT]: T };

export const templateConfig: {
  /** 开场设置 - 页面加载样式功能  */
  openingLoading: TRecord<boolean>;
  /** 开场设置 - 开场沙盘 */
  openingSandtable: TRecord<boolean>;
  /** 界面设置 - 自定义LOGO */
  logo: TRecord<boolean>;
  /** 界面设置 - 搜索设置 */
  searchSetting: TRecord<boolean>;
  /** 全局开关中的设置 */
  globalFlagsSettings: TRecord<{
    /** 是否有`返回首场景设置`功能 */
    backToFirstScene?: true;
    /** 是否有`作品简介`开关, `undefined`表示没有 */
    remark?: {
      /** `作品简介`是否支持设置图标 */
      icon: boolean;
      /** `作品简介`是否有足迹开关 */
      map: boolean;
    };
  }>;
  /** 界面设置 - 免责声明 */
  copyright: TRecord<boolean>;
  /** 界面设置 - 界面语言 */
  language: TRecord<boolean>;
  /** 界面设置 - 界面配色 */
  uiColor: TRecord<EditConfigUI | null>;
  /** 自定义按钮 - 最大按钮数 */
  customButton: TRecord<number>;
  /** `自定义按钮`是否能设置图标 */
  customButtonIcon: TRecord<boolean>;
  /** `场景选择`图标设置 */
  categroyConfigIcon: TRecord<{
    /** `场景选择`默认图标, 无值表示没有`图标设置`功能 */
    icon?: string;
    /** `场景选择`是否有`标题设置`的功能 */
    title?: boolean;
  }>;
  /** `场景选择` - 选择栏设置里的`打开作品时显示场景选择栏`开关 */
  defaultShowColumn: TRecord<boolean>;
  /** `导览` - `AI讲解` - `AI视频讲解` 功能 */
  autoRotateVideo: TRecord<boolean>;
} = {
  openingLoading: {
    [TemplateId.free]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  openingSandtable: {
    [TemplateId.free]: false,
    [TemplateId.realEstateB]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  logo: {
    [TemplateId.free]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  globalFlagsSettings: {
    [TemplateId.free]: { remark: { icon: true, map: true } },
    [TemplateId.vip]: { remark: { icon: true, map: true } },
    [TemplateId.simple]: { remark: { icon: false, map: false } },
    [TemplateId.realEstateB]: { backToFirstScene: true },
    [TemplateId.legacy]: { remark: { icon: true, map: true } },
    [TemplateId.project]: { remark: { icon: false, map: true } },
    [TEMPLATE_DEFAULT]: {},
  },
  searchSetting: {
    [TemplateId.free]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  copyright: {
    [TemplateId.realEstateA]: true,
    [TemplateId.realEstateB]: true,
    [TEMPLATE_DEFAULT]: false,
  },
  language: {
    [TemplateId.free]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  uiColor: {
    [TemplateId.simple]: {
      fontColor: '255,255,255,1',
      fontAvtiveColor: '255,255,255,1',
      bgColor: '0,0,0,1',
      btnActiveColor: '40,110,250,1',
      panelBgColor: '0,0,0,0.3',
    },
    [TemplateId.realEstateA]: {
      fontColor: '255,255,255,1',
      fontAvtiveColor: '255,255,255,1',
      bgColor: '255,255,255,0.15',
      btnActiveColor: '255,85,0,0.8',
      panelBgColor: '0,0,0,0.5',
    },
    [TemplateId.realEstateB]: {
      fontColor: '255,255,255,0.7',
      fontAvtiveColor: '255,255,255,1',
      bgColor: '255,255,255,0.15',
      btnActiveColor: '255,85,0,0.8',
      panelBgColor: '0,0,0,0.5',
    },
    [TemplateId.project]: {
      fontColor: '51,51,51,1',
      fontAvtiveColor: '250,100,0,1',
      bgColor: '0,0,0,0.05',
      btnActiveColor: '0,0,0,0.05',
      panelBgColor: '255,255,255,1',
    },
    [TemplateId.vip]: {
      fontColor: '255,255,255,1',
      fontAvtiveColor: '250,100,0,1',
      bgColor: '0,0,0,0.3',
      btnActiveColor: '0,0,0,0.8',
      panelBgColor: '0,0,0,0.3',
    },
    [TemplateId.legacy]: {
      fontColor: '255,255,255,1',
      fontAvtiveColor: '236,185,95,1',
      bgColor: '0,0,0,0.3',
      btnActiveColor: '0,0,0,0.8',
      panelBgColor: '0,0,0,0.5',
    },
    [TemplateId.metaverseA]: {
      fontColor: '255,255,255,1',
      fontAvtiveColor: '255,255,255,1',
      bgColor: '0,0,0,0.3',
      btnActiveColor: '40,110,250,1',
      panelBgColor: '0,0,0,0.5',
    },
    [TEMPLATE_DEFAULT]: null,
  },
  customButton: {
    [TemplateId.vip]: 3,
    [TemplateId.simple]: 4,
    [TemplateId.realEstateA]: 10,
    [TemplateId.metaverseA]: 4,
    [TemplateId.realEstateB]: 5,
    [TemplateId.legacy]: 3,
    [TemplateId.project]: 10,
    [TEMPLATE_DEFAULT]: 0,
  },
  customButtonIcon: {
    [TemplateId.realEstateA]: false,
    [TemplateId.project]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  categroyConfigIcon: {
    [TemplateId.free]: {
      icon: '/imgs/scene.e2de3aaf3396622d4625a6e98db9b3e5.png',
      title: true,
    },
    [TemplateId.vip]: {
      icon: '/imgs/scene.e2de3aaf3396622d4625a6e98db9b3e5.png',
      title: true,
    },
    [TemplateId.simple]: {
      icon: '/imgs/list.07783afd9139350ac463ec7a9c8e4d3d.png',
      title: true,
    },
    [TemplateId.realEstateA]: {
      icon: '/imgs/scene-rea.be1aa9b00d4ab45a22731dee9fbbcec1.png',
      title: true,
    },
    [TemplateId.legacy]: {
      icon: '/imgs/list.1405ce71491e460ad4e5b452de7bf56e.png',
      title: false,
    },
    [TEMPLATE_DEFAULT]: {},
  },
  defaultShowColumn: {
    [TemplateId.realEstateB]: false,
    [TEMPLATE_DEFAULT]: true,
  },
  autoRotateVideo: {
    [TemplateId.metaverseA]: true,
    [TemplateId.realEstateB]: true,
    [TemplateId.legacy]: true,
    [TemplateId.vip]: true,
    [TemplateId.project]: true,
    [TEMPLATE_DEFAULT]: false,
  },
};

export const getTemplateConfig =
  (templateId: TemplateId) =>
  <T extends keyof typeof templateConfig>(key: T) => {
    const configMap = templateConfig[key];
    return (configMap[templateId] ?? configMap[TEMPLATE_DEFAULT]) as Exclude<
      (typeof templateConfig)[T][TemplateId | typeof TEMPLATE_DEFAULT],
      undefined
    >;
  };

export default templateConfig;
